"use client";

import React from "react";
import { Facebook, Instagram, Compass } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <nav className="flex flex-wrap justify-center gap-6 mb-10">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-4 w-16 bg-muted animate-pulse rounded-md" />)}
      </nav>;
  }
  return <nav className="flex flex-wrap justify-center gap-8 mb-10">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm font-default tracking-wide text-muted-foreground hover:text-primary transition-colors duration-300">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="221644" id="footer" className="bg-background py-16 flex flex-col items-center text-center px-6">
      <div className="w-full max-w-4xl mx-auto flex flex-col items-center">
        
        {}
        <Link to="/HomePage" className="mb-10 inline-block transition-opacity hover:opacity-80">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662466/img/nexus_precision_logo_footer.png" alt="NEXUS Precision" className="h-7 w-auto object-contain" />
        </Link>

        {}
        <MenuProvider menu_id="16">
          <FooterNavigation />
        </MenuProvider>

        {}
        <div className="flex items-center justify-center gap-8 mb-12">
          <Link to="#" aria-label="Instagram" className="group">
            <Instagram className="size-5 text-muted-foreground stroke-[1.25] group-hover:text-secondary transition-colors duration-300" />
          </Link>
          <Link to="#" aria-label="Facebook" className="group">
            <Facebook className="size-5 text-muted-foreground stroke-[1.25] group-hover:text-secondary transition-colors duration-300" />
          </Link>
          <Link to="#" aria-label="Tripadvisor" className="group">
            <Compass className="size-5 text-muted-foreground stroke-[1.25] group-hover:text-secondary transition-colors duration-300" />
          </Link>
        </div>

        {}
        <div className="w-full max-w-md flex flex-col items-center">
          <Separator className="bg-border mb-6 w-full" />
          <p className="text-[10px] tracking-widest text-muted-foreground uppercase font-default">
            © {currentYear} NEXUS Precision. High-Intelligence Professional Systems.
          </p>
        </div>

      </div>
    </section>;
}